import { useTranslate } from '@repo/shared/hooks'
import { Button, Col, Icon } from '@repo/ui/components'
import Image from 'next/image'
import React, { useRef, useState } from 'react'

interface JobQualificationsUploadProps {
  onFileUpload: (files: File[]) => void
}

export const JobQualificationsUpload = (
  props: JobQualificationsUploadProps,
) => {
  const { onFileUpload } = props
  const { t } = useTranslate()
  const fileInputRef = useRef<HTMLInputElement>(null)
  const [isDragging, setIsDragging] = useState(false)

  const handleButtonClick = () => {
    fileInputRef.current?.click()
  }

  const handleFileInputChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const files = Array.from(event.target.files || []) as File[]
    if (files.length > 0) {
      onFileUpload(files)
    }
  }

  const handleDragEnter = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault()
    event.stopPropagation()
    setIsDragging(true)
  }

  const handleDragLeave = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault()
    event.stopPropagation()
    setIsDragging(false)
  }

  const handleDragOver = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault()
    event.stopPropagation()
  }

  const handleDrop = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault()
    event.stopPropagation()
    setIsDragging(false)

    const files = Array.from(event.dataTransfer.files || []) as File[]
    if (files.length > 0) {
      onFileUpload(files)
    }
  }

  return (
    <div
      className={`border-2 border-dashed rounded-md p-md cursor-pointer transition-colors ${
        isDragging
          ? 'border-base-main bg-base-surface-10'
          : 'border-base-surface-40 hover:border-base-main'
      }`}
      onDragEnter={handleDragEnter}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
    >
      <input
        ref={fileInputRef}
        type='file'
        multiple
        accept='.pdf,.jpg,.jpeg,.png,.doc,.docx'
        onChange={handleFileInputChange}
        className='hidden'
      />

      <Col className='items-center gap-md'>
        <Image
          src='/images/upload-qualifications.webp'
          alt=''
          priority
          width={80}
          height={80}
          className='w-20 h-20'
        />
        <Button onClick={handleButtonClick} width='full'>
          <Icon name='Plus' size='sm' className='mr-xs' />
          {t('agents_job_qualifications_upload_button')}
        </Button>
      </Col>
    </div>
  )
}
